import React from "react";
import { useNavigate } from "react-router-dom";
import "./MoneyMagicDay.css";

function UntangleComplete() {
  const navigate = useNavigate();

  return (
    <div className="mmd-jc-page">
      <div className="mmd-jc-inner">
        <p className="mmd-jc-eyebrow">Edge &amp; Altar · The Untangle Journal</p>
        <div className="mmd-jc-ornament">✦</div>
        <h1 className="mmd-jc-title">You finished the Untangle Journal.</h1>
        <p className="mmd-jc-body">
          Seven days. Seven spells. Seven honest looks at what you were carrying
          and where it came from. The work you did this week isn't lost when you
          close this journal. It's in your body now — in the patterns you
          interrupted, the edges you found, the things you chose to put down.
        </p>
        <p className="mmd-jc-body">
          Untangling isn't a one-time event. It's a practice. And you now have
          the spells to come back to any time you feel the knots forming.
        </p>

        <div style={{ display: "flex", flexDirection: "column", gap: 12, marginTop: 32 }}>
          <button
            className="mmd-jc-btn"
            type="button"
            onClick={() => navigate("/library")}
            style={{ marginTop: 0 }}
          >
            Browse the Spell Library
          </button>
          <a
            className="mmd-jc-btn"
            href="https://www.edgeandaltar.com/money-magic-journal"
            target="_blank"
            rel="noreferrer"
            style={{ marginTop: 0, display: "block", textDecoration: "none" }}
          >
            The Money Magic Journal →
          </a>
          <button
            className="mmd-jc-btn"
            type="button"
            onClick={() => navigate("/subscribe")}
            style={{ marginTop: 0 }}
          >
            Unlock Premium
          </button>
        </div>
      </div>
    </div>
  );
}

export default UntangleComplete;
